var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHalfSun = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 7.946,
    viewBox: "0 0 14 7.946",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-263.247 -904.843)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-251.305,215.765v-.049a4.515,4.515,0,0,0-4.533-4.426,4.515,4.515,0,0,0-4.533,4.426v.049h-2.459v.82h14v-.82Zm-8.246,0v-.025a3.693,3.693,0,0,1,3.713-3.631,3.7,3.7,0,0,1,3.713,3.631v.025Z",
    transform: "translate(526.077 696.204)",
    fill: "#ed7000"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.263,
    height: 0.82,
    transform: "translate(270.899 907.058) rotate(-77.993)",
    fill: "#ed7000"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.82,
    height: 2.263,
    transform: "translate(268.344 905.014) rotate(-12.033)",
    fill: "#ed7000"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.264,
    height: 0.82,
    transform: "matrix(0.577, -0.817, 0.817, 0.577, 272.817, 907.713)",
    fill: "#ed7000"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.82,
    height: 2.264,
    transform: "matrix(0.817, -0.577, 0.577, 0.817, 265.721, 906.337)",
    fill: "#ed7000"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 2.264,
    height: 0.82,
    transform: "translate(274.461 909.273) rotate(-30.071)",
    fill: "#ed7000"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 0.82,
    height: 2.264,
    transform: "translate(263.703 908.833) rotate(-61.001)",
    fill: "#ed7000"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHalfSun);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/half-sun.2da304fe60dff4065d1e4bc2e0083e2b.svg";